import { render, staticRenderFns } from "./DeliverAdresses.vue?vue&type=template&id=52e989d4&scoped=true&"
import script from "./DeliverAdresses.vue?vue&type=script&lang=js&"
export * from "./DeliverAdresses.vue?vue&type=script&lang=js&"
import style0 from "./DeliverAdresses.vue?vue&type=style&index=0&id=52e989d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e989d4",
  null
  
)

export default component.exports